export type ClubOwnerSetupTaskId =
  | 'sports'
  | 'courts'
  | 'organization_profile'
  | 'stripe_connect'
  | 'court_hire'
  | 'memberships'
  | 'inventory';

export type ClubSetupPageTourKey =
  | 'organization-settings'
  | 'academy-payments-settings'
  | 'club-court-hire'
  | 'club-members'
  | 'club-inventory';

const CLUB_SETUP_TASK_TOUR_KEY_MAP: Partial<Record<ClubOwnerSetupTaskId, ClubSetupPageTourKey>> = {
  sports: 'organization-settings',
  organization_profile: 'organization-settings',
  stripe_connect: 'academy-payments-settings',
  court_hire: 'club-court-hire',
  memberships: 'club-members',
  inventory: 'club-inventory',
};

/** Maps a club getting-started checklist task to its page tour key. */
export function resolveClubSetupTaskTourKey(
  taskId: ClubOwnerSetupTaskId,
): ClubSetupPageTourKey | null {
  return CLUB_SETUP_TASK_TOUR_KEY_MAP[taskId] ?? null;
}
